import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/pedidosdashboard",
    name: "PedidosDaschboard",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/itenspedfrm",
    name: "ItensPedFrm",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/ItensPedFrm.vue"),
    children: [
      {
        path: ":idPedido",
        component: () => import("../views/ItensPedFrm.vue"),
      }
    ]
  },
  {
    path: "/itenspedlista",
    name: "ItensPedLista",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/ItensPedLst.vue"),
    children: [
      {
        path: ":idPedido",
        component: () => import("../views/ItensPedLst.vue"),
      }
    ]
  },
  {
    path: "/pedidofrm",
    name: "PedidoFrm",
    beforeEnter: routeGuard,
    component: () => import("../views/PedidoFrm.vue"),
  },
  {
    path: "/pedidofrm/:pedidoid",
    name: "PedidoFrm",
    beforeEnter: routeGuard,
    component: () => import("../views/PedidoFrm.vue"),
    props: route => ({
      pedidos: route.query.pedidoid ? JSON.stringify(route.query.pedidoid) : [3509927]
    })
  },
  {
    path: "/pedidoslst",
    name: "PedidosLst",
    beforeEnter: routeGuard,
    component: () => import("../views/Pedidos.vue"),
	},
  {
    path: "/depositos/:status",
    beforeEnter: routeGuard,
    component: () => import("../views/DepositosLst.vue"),
	},
  {
    path: "/depositos",
    name: "DepositosLst",
    beforeEnter: routeGuard,
    component: () => import("../views/DepositosLst.vue"),
	},
  {
    path: "/depositofrm/:id",
    component: () => import("../views/DepositosFrm.vue"),
    beforeEnter: routeGuard,
    props: route => ({
      pedidos: route.query.pedidos ? JSON.stringify(route.query.pedidos) : [3509927]
    })
	},
  {
    path: "/depositofrm",
    name: "DepositoFrm",
    beforeEnter: routeGuard,
    component: () => import("../views/DepositosFrm.vue"),
	},
  {
    path: "/depositosdashboard",
    name: "DepositosDashboard",
    beforeEnter: routeGuard,
    component: () => import("../views/DepositosDashboard.vue"),
	},
];
